import React from 'react';
import Modal from "../modal/modal";
import styles from "./complete-modal.css";
import ButtonComponent from "../../../components/button/button";
import gif from "../modal/gif021.gif"

const CompleteModal = ({title, tips, restudyTitle, onRestudy, nextTitle, onNext, exitTitle, onExit, onSubmit, onClose, finish=true,content}) => {
    return (
        <Modal
            title={title}
            tips={tips}
            onClose={onClose}
        >
            {
                content ? (
                    <div style={{textAlign:'center'}}><span style={{fontWeight:'bold'}}>{content}</span> 已完成</div>
                ):(null)
            }
            <div className={styles.wrapper}>
                {onNext && <ButtonComponent className={styles.button} onClick={() => {onNext(); onSubmit();}}>{nextTitle}</ButtonComponent>}
                {onRestudy && <ButtonComponent className={styles.button} onClick={() => {onRestudy(); onSubmit();}}>{restudyTitle}</ButtonComponent>}
                {onExit && <ButtonComponent className={styles.button} onClick={() => {onExit();}}>{exitTitle}</ButtonComponent>}
            </div>
            {finish ? (
                <div className={styles.Ribbons}>
                    <img src={gif} />
                    <img className={styles.gif} src={gif} />
                </div>
            ) : (null)}
        </Modal>
    )
}

export default CompleteModal;
